
  import { Vue, Component, Prop } from "vue-property-decorator";
  import CREATE_APPLICATION from "@/apollo/applications/CreateApplication.gql";
  import PlusIcon from "@/components/icons/PlusIcon.vue";
  import UiButton from "@/components/button/ui-button.vue";
  import UPDATE_USER_APPLICATION from "@/apollo/jobboard/UpdateUserApplication.gql";
  import { Application_Set_Input } from "@/generated/graphql";
  import MinusIcon from "@/components/icons/MinusIcon.vue";
  @Component({
    components: {
      UiButton,
      PlusIcon,
      MinusIcon
    },
    model: {
      prop: "applicationExists",
      event: "toggle"
    }
  })
  export default class ApplyButton extends Vue {
    @Prop({type: String, required: true}) readonly currentUserId!: string;
    @Prop({type: String, required: true}) readonly postingId!: string;
     @Prop({type: String, default: "lg"}) readonly size!: string;
    @Prop({type: String, default: "linkButton"})  variant!: string;
    @Prop({type: Boolean, default: false}) readonly applicationExists!: boolean;
    @Prop({type: String, default: undefined}) readonly applicationId?: string;
     @Prop({type: String, default: true}) readonly showIcon?: string;
    @Prop({type: String, default: '', required: false}) readonly buttonClasses?: string;
    @Prop({type: Boolean, default: false}) readonly isCancelled!: boolean;
    @Prop({type: String, default: 'Apply', required: false}) readonly applyBtnText!: string;
    @Prop({type: String, default: 'Withdraw Application', required: false}) readonly withdrawBtnText!: string;

    processing: boolean = false;
    isApply: boolean = true;
    localApplicationId?: string = undefined;
get isWidthraw(){
  return !(!this.applicationExists || this.isCancelled)
}
    get buttonText(): string {
      if (!this.applicationExists || this.isCancelled) {
        this.variant = 'default'
        return this.applyBtnText;
      }
      this.isApply = true;
      this.variant='outline-black'
      return this.withdrawBtnText;
    }

    async handleClick(): Promise<void> {
      this.processing = true;
      if (this.applicationExists && !this.isCancelled) {
        await this.cancelApplication();
        this.$emit('toggle', false);
      } else {
        await this.applyForPosting();
        this.$emit('toggle', true);
      }
      this.processing = false;
    }

    async applyForPosting(): Promise<void> {
      if (!this.applicationId && !this.localApplicationId) {
        await this._createApplication();
      } else {
        let set: Application_Set_Input = {
          is_cancelled: false,
        }
        await this.updateApplication(set)
      }
    }

    async cancelApplication(): Promise<void> {
      const set: Application_Set_Input = {
        interviewed_by: null,
        is_cancelled: true,
        document_id: null,
        note: null,
      }
      await this.updateApplication(set);
    }

    async _createApplication(): Promise<void> {
      const res =  await this.$apollo.mutate({
        mutation: CREATE_APPLICATION,
        variables: {
          object: {
            posting_id: this.postingId,
            user_id: this.currentUserId,
          },
        }
      });
      this.localApplicationId = res.data.insert_application_one.id;
    }

    updateApplication(set: Application_Set_Input) {
      const id = this.applicationId || this.localApplicationId;
      return this.$apollo.mutate({
        mutation: UPDATE_USER_APPLICATION,
        variables: {
          where: {
            id: { _eq: id },
          },
          set,
        },
      });
    }
  }
